import { get } from "../api_helper";

export const getIndustriapi=()=>get('industries');